 import { Component } from '@angular/core';
import { ReportManagementService } from '../../services/report-management.service';
import { AdjustmentUi } from '../models/adjustment-ui.model';

@Component ({
    selector: 'app-vehicle-adjustments',
    templateUrl: './vehicle-adjustments.component.html',
    styleUrls: [ './vehicle-adjustments.component.scss' ]
})

export class VehicleAdjustmentsComponent {
    vehicles: Array<AdjustmentUi> = new Array<AdjustmentUi>();
    hasSaved = false;

    categories;

    constructor (private reportManagementService: ReportManagementService) {
        this.reportManagementService.verifyAdjustmentsAccess();
        this.reportManagementService.onManufacturerListUpdated.subscribe(data => {
            this.vehicles = data;
        });
        this.reportManagementService.getAllManufacturers();
        this.categories = this.reportManagementService.vehicleCategories;
    }

    onChange() {
        this.reportManagementService.vehicles = this.vehicles;
    }
}



// WEBPACK FOOTER //
// ./src/app/report/adjustments/components/vehicle-adjustments.component.ts